<div class="bar-chart-comparison-container">
    <div class="header">
        <h2>{{ title }}</h2>
        <p class="subtitle">Compare universities across different metrics</p>
    </div>

    <!-- Metric Selector -->
    <div class="metric-selector">
        <label for="metric-select">Select Metric:</label>
        <select id="metric-select" (change)="onMetricChange($event)" [value]="selectedMetric">
            <option *ngFor="let metric of availableMetrics" [value]="metric">
                {{ metric | titlecase }}
            </option>
        </select>
    </div>

    <!-- Main Content: Side-by-side layout for laptop and bigger screens -->
    <div class="main-content">
        <!-- Bar Chart Section -->
        <div class="chart-section">
            <div class="chart-container">
                <ngx-charts-bar-vertical [view]="view" [scheme]="'vivid'" [results]="chartData" [gradient]="false"
                    [xAxis]="true" [yAxis]="true" [legend]="false" [showXAxisLabel]="true" [showYAxisLabel]="true"
                    [xAxisLabel]="'Universities'" [yAxisLabel]="selectedMetric" [animations]="true">
                </ngx-charts-bar-vertical>
            </div>
        </div>

        <!-- Detailed Comparison Table Section -->
        <div class="table-section">
            <div class="comparison-table">
                <h3>Detailed Comparison</h3>
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>Rank</th>
                                <th>University</th>
                                <th>{{ selectedMetric | titlecase }}</th>
                                <th>Performance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of chartData; let i = index">
                                <td class="rank">{{ i + 1 }}</td>
                                <td class="university-name">{{ item.name }}</td>
                                <td class="score">{{ item.value }}</td>
                                <td class="performance">
                                    <div class="performance-bar">
                                        <div class="bar-fill" [style.width.%]="item.value"
                                            [style.background-color]="getMetricColor(item.value)">
                                        </div>
                                    </div>
                                    <mat-icon [style.color]="getMetricColor(item.value)">
                                        {{ getMetricIcon(item.value) }}
                                    </mat-icon>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- Summary Cards -->
    <div class="summary-cards">
        <div class="summary-card top-performer" *ngIf="chartData.length > 0">
            <mat-icon>emoji_events</mat-icon>
            <h4>Top Performer</h4>
            <p>{{ chartData[0].name }}</p>
            <span class="score">{{ chartData[0].value }}</span>
        </div>

        <div class="summary-card average" *ngIf="chartData.length > 0">
            <mat-icon>analytics</mat-icon>
            <h4>Average Score</h4>
            <p>{{ getAverageScore() }}</p>
        </div>

        <div class="summary-card range" *ngIf="chartData.length > 0">
            <mat-icon>trending_up</mat-icon>
            <h4>Score Range</h4>
            <p>{{ getScoreRange() }}</p>
        </div>
    </div>
</div>
